"use client";

import Link from "@/app/[lang]/_components/Link";
import { createT } from "@/app/[lang]/_utils/create-t";
import type { Lang } from "@/langs";
import { api } from "@/trpc/react";
import { Button } from "@borderless/ui/components/button";
import { ArrowLeft01Sharp } from "@borderless/ui/icons";
import { useSearchParams } from "next/navigation";
import { Suspense, type FC } from "react";
import dictionary from "./t.json";

const t = createT(dictionary);

export const BackToStoriesLink: FC<{
  lang: Lang;
}> = (props) => {
  return (
    <Suspense>
      <BackToStoriesLinkContent {...props} />
    </Suspense>
  );
};

const BackToStoriesLinkContent: FC<{
  lang: Lang;
}> = (props) => {
  const searchParams = useSearchParams();
  const fromPlaylist = searchParams.get("from") === "playlist";
  const playlistSlug = searchParams.get("slug");

  // Check if playlist exists using tRPC
  const { data: playlistExists, isLoading } =
    api.playlist.checkIfExists.useQuery(
      { slug: playlistSlug },
      {
        enabled: fromPlaylist && !!playlistSlug,
        retry: false,
        refetchOnWindowFocus: false,
      },
    );

  const finalHref =
    fromPlaylist && playlistSlug && playlistExists
      ? `/stories/playlists/${playlistSlug}`
      : "/stories";

  const linkText =
    fromPlaylist && playlistExists ? "Back to Playlist" : "Back to All Stories";

  return (
    <Button variant="ghost" asChild>
      <Link href={finalHref}>
        <ArrowLeft01Sharp />
        {isLoading
          ? t("Back to All Stories", props.lang)
          : t(linkText, props.lang)}
      </Link>
    </Button>
  );
};
